import { render, staticRenderFns } from "./Secondary.vue?vue&type=template&id=0f0f2a4c"
import script from "./Secondary.vue?vue&type=script&lang=js"
export * from "./Secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports